import type { DeleteDataImportByIdMutation } from '@risksmart-app/web-graphql-client/generated/graphql';
import { DeleteDataImportByIdDocument } from '@risksmart-app/web-graphql-client/generated/graphql';

import { createMutationHook } from '@/utils/hook-factories';

export const useDeleteDataImportById = createMutationHook({
  name: 'deleteDataImportById',
  mutationOptions: (trpc, onSuccess) =>
    trpc.frontend.dataImport.deleteDataImportById.mutationOptions({
      onSuccess,
    }),
  mapInput: (id: string) => ({ id }),
  invalidate: (trpc) => [
    trpc.frontend.dataImport.dataImports.queryKey(),
    // The detail query is keyed per-id (useGetDataImportById →
    // dataImportById.queryOptions({ id })); invalidate the whole family so
    // the deleted record is not left cached on the update page / back-nav.
    trpc.frontend.dataImport.dataImportById.queryKey(),
  ],
  mapResponse: (result: {
    affected_rows: number;
  }): DeleteDataImportByIdMutation => ({
    delete_data_import: {
      __typename: 'data_import_mutation_response',
      affected_rows: result.affected_rows,
    },
  }),
  graphqlDocument: DeleteDataImportByIdDocument,
  graphqlVariables: (id: string) => ({ id }),
  evictFields: ['data_import'],
});
